import {Component, ComponentFactory, ComponentFactoryResolver, Input, ViewChild, ViewContainerRef} from '@angular/core';
import {GnTableComponent} from '../table/table.component';
import {GnTableButtonConfig} from './TableButtonConfig';
import {tableButtonTypes} from './TableButton';
import {GnModalButtonDirective} from '../modal-button/modal-button.directive';

@Component({
  selector: 'gn-table-button',
  templateUrl: './table-button.component.html',
  styleUrls: ['./table-button.component.less']
})
export class GnTableButtonComponent {

  private configValue: GnTableButtonConfig;

  @Input() table: GnTableComponent;

  @Input() set config(config: GnTableButtonConfig) {
    this.configValue = config;

    if (this.config && this.config.other) {
      const otherType = tableButtonTypes[this.config.other];
      if (!otherType) {
        throw new Error(`表格按钮组件[${this.config.other}]未注册`);
      }
      const controlFactory: ComponentFactory<any> = this.resolver.resolveComponentFactory(otherType);
      const componentRef = this.container.createComponent(controlFactory);
      componentRef.instance.table = this.table;
    }
  }

  get config(): GnTableButtonConfig {
    return this.configValue;
  }

  @ViewChild('other', {read: ViewContainerRef}) container: ViewContainerRef;
  @ViewChild('newButton', {read: GnModalButtonDirective}) newButton: GnModalButtonDirective;
  @ViewChild('editButton', {read: GnModalButtonDirective}) editButton: GnModalButtonDirective;

  constructor(private resolver: ComponentFactoryResolver) {
  }

  assignObject(params: any, dataId: any): any {
    if (!params) {
      return dataId;
    }
    return Object.assign(params, dataId);
  }

}
